/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';

import { CircularProgress, Typography } from '@material-ui/core';
import { OrbitControls } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

const LoadedObj = ({ setTarget, model }) => {
  const { camera } = useThree();
  const centerObject = useCallback(
    (object) => {
      const box = new THREE.Box3().setFromObject(object);
      const size = box.getSize(new THREE.Vector3()).length();
      const center = box.getCenter(new THREE.Vector3());
      camera.translateZ(size * -1.5);
      camera.translateY(box.max.y / 2);

      setTarget(center);
    },
    [camera, setTarget]
  );

  useEffect(() => {
    if (model?.scene) centerObject(model.scene);
  }, [model, centerObject]);

  return <>{model ? <primitive object={model.scene} dispose={null} /> : null}</>;
};

export default ({ url, dimensions, uuid }) => {
  const height = dimensions ? dimensions.height : '75vh';
  const width = dimensions ? dimensions.width : '50vw';
  // for testing only
  // url = 'https://threejs.org/examples/models/fbx/Samba%20Dancing.fbx';
  // url = 'http://localhost:3003/1.fbx';
  const [target, setTarget] = useState(new THREE.Vector3());
  const [model, setModel] = useState();
  const [downloadStatus, setDownloadStatus] = useState('init');
  const [downloadProgress, setDownloadProgress] = useState('');

  useEffect(() => {
    if (url) {
      console.log(`3DModelUUID-${uuid || ''}_DownloadingObject`);
      setDownloadStatus('downloading');
      new GLTFLoader().load(
        url,
        (obj) => {
          setModel(obj);
          console.log(`3DModelUUID-${uuid || ''}_ObjectLoaded`);
          setDownloadStatus('downloaded');
        },
        (data) => {
          const loaded = data?.loaded || 0;
          const totalData = data?.total || 1;
          const result = totalData === 1 ? 0 : ((loaded * 100) / totalData).toFixed(1);
          setDownloadProgress(result);
        },
        () => {
          console.log(`3DModelUUID-${uuid || ''}_DownloadFailed`);
          setDownloadStatus('failed');
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, uuid]);

  if (!model && downloadStatus === 'downloading') {
    return (
      <div style={{ alignItems: 'center', display: 'flex', height, justifyContent: 'center', width }}>
        <CircularProgress />
        <Typography style={{ marginLeft: '24px' }}>
          Downloading
          {downloadProgress ? <span> ({downloadProgress}%)</span> : '...'}
        </Typography>
      </div>
    );
  }

  if (!model && downloadStatus === 'failed') {
    return (
      <div style={{ alignItems: 'center', display: 'flex', height, justifyContent: 'center', width }}>
        <Typography style={{ marginLeft: '24px' }}>Failed to download the 3d object</Typography>
      </div>
    );
  }

  return (
    <div style={{ height, width }}>
      <Canvas colorManagement camera={{ far: 10000, near: 0.01, position: [0, 0, 0] }}>
        <LoadedObj model={model} setTarget={setTarget} />
        <ambientLight intensity={0.4} color="white" />
        <directionalLight position={[0, 1, 1]} intensity={0.7} color="white" />
        <directionalLight position={[-1, -1, -1]} intensity={0.7} color="white" />
        <OrbitControls target={target} />
      </Canvas>
    </div>
  );
};
